import { useMutation } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import api from '@/constant/END_POINT'

const postCancelCeClaim = async (claimFormId: string) => {
  const response = await httpClientPrivate.post(api.backoffice.cancelCeClaim(claimFormId))

  return response.data
}

const useCancelCeClaim = () => {
  return useMutation({
    mutationKey: ['useCancelCeClaim'],
    mutationFn: async (claimFormId: string) => postCancelCeClaim(claimFormId),
  })
}

export { useCancelCeClaim }
